export type MediaType = "movie" | "tv";

export interface MediaEpisode {
  id: string;
  index: number;
  title: string;
  duration: string;
}

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  cover: string;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  popularity: number;
  publishedAt: string;
  director: string;
  actors: string[];
  duration: string;
  tagline: string;
  synopsis: string;
  episodes: MediaEpisode[];
}

export const mediaList: MediaItem[] = [
  {
    id: "interstellar-dawn",
    title: "星际迷航：黎明边境",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20art%2C%20lone%20astronaut%20standing%20before%20a%20glowing%20ringed%20planet%2C%20epic%20dramatic%20lighting%2C%20deep%20navy%20and%20amber%20tone%2C%20minimal%20clean%20background%2C%20centered%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m1&orientation=portrait",
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    popularity: 96,
    publishedAt: "2025-08-12",
    director: "艾米莉亚·沃德",
    actors: ["诺亚·贝克", "林赛·科尔", "伊桑·瑞德"],
    duration: "148分钟",
    tagline: "当星门开启，人类第一次听见宇宙的回声。",
    synopsis:
      "一支由顶尖宇航员组成的探险队穿越未知星门，抵达一颗被永久黄昏笼罩的行星。他们必须在资源耗尽前解开这颗星球留下的谜题，同时直面各自心底最深的失去。",
    episodes: [],
  },
  {
    id: "night-hunt",
    title: "暗夜追凶",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20art%2C%20shadowy%20detective%20silhouette%20in%20a%20rainy%20neon%20alley%2C%20moody%20low%20key%20lighting%2C%20deep%20blue%20with%20amber%20highlights%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20professional%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m2&orientation=portrait",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    popularity: 92,
    publishedAt: "2025-07-30",
    director: "陈默",
    actors: ["张寒", "李沐", "周正"],
    duration: "126分钟",
    tagline: "这座城市没有真正的黑夜，只有藏起来的光。",
    synopsis:
      "一桩连环失踪案将一名失意的老刑警重新拉回一线。线索指向他二十年前亲手结案的旧案，真相与记忆的裂缝之间，他必须做出抉择。",
    episodes: [],
  },
  {
    id: "changan-dream",
    title: "长安幻夜",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20fantasy%20movie%20poster%20art%2C%20elegant%20figure%20in%20flowing%20hanfu%20beneath%20glowing%20lanterns%2C%20mystical%20night%20lighting%2C%20deep%20indigo%20and%20gold%20tones%2C%20minimal%20clean%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m3&orientation=portrait",
    genres: ["古装", "奇幻", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    popularity: 88,
    publishedAt: "2024-12-18",
    director: "苏晚",
    actors: ["沈砚", "柳青禾", "白景行"],
    duration: "132分钟",
    tagline: "灯影摇曳处，藏着长安不为人知的另一面。",
    synopsis:
      "大唐盛世的长安城接连发生离奇幻象，一名游方术士与一名女捕快被迫联手。他们发现所有幻象都指向二十年前一场被抹去的宫廷大火。",
    episodes: [],
  },
  {
    id: "tender-years",
    title: "温柔岁月",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%20art%2C%20two%20figures%20under%20warm%20afternoon%20sunlight%20by%20a%20window%2C%20soft%20gentle%20lighting%2C%20warm%20cream%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20professional%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m4&orientation=portrait",
    genres: ["剧情", "爱情"],
    region: "中国台湾",
    year: 2024,
    rating: 7.9,
    popularity: 74,
    publishedAt: "2024-10-05",
    director: "林知夏",
    actors: ["许念", "程野", "方以宁"],
    duration: "118分钟",
    tagline: "有些人陪你把日子过成了岁月。",
    synopsis:
      "小城书店的老板与来此旅居的画家在漫长的夏季里相遇。两人用一封封未寄出的信，记录下那些被时间温柔收藏的日常。",
    episodes: [],
  },
  {
    id: "velocity-fury",
    title: "极速狂飙",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20racing%20movie%20poster%20art%2C%20sleek%20sports%20car%20speeding%20through%20a%20night%20city%20with%20light%20trails%2C%20high%20contrast%20lighting%2C%20deep%20navy%20and%20amber%20color%2C%20minimal%20clean%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m5&orientation=portrait",
    genres: ["动作", "赛车"],
    region: "美国",
    year: 2025,
    rating: 7.6,
    popularity: 90,
    publishedAt: "2025-06-21",
    director: "马库斯·李",
    actors: ["德里克·凯恩", "佐伊·马丁", "雷·冈萨雷斯"],
    duration: "124分钟",
    tagline: "在这条街上，只有快和更快。",
    synopsis:
      "退役车手为了偿还弟弟的债务重返地下赛圈，却卷入一场横跨三座城市的飙车阴谋。他必须用最熟悉的方式，赢回被夺走的一切。",
    episodes: [],
  },
  {
    id: "deep-rescue",
    title: "深海救援",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20disaster%20adventure%20movie%20poster%20art%2C%20diver%20descending%20into%20a%20deep%20dark%20ocean%20with%20light%20rays%2C%20dramatic%20moody%20lighting%2C%20deep%20teal%20navy%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m6&orientation=portrait",
    genres: ["灾难", "冒险"],
    region: "英国",
    year: 2024,
    rating: 7.8,
    popularity: 71,
    publishedAt: "2024-09-14",
    director: "奥利弗·格雷",
    actors: ["艾拉·福斯特", "汤姆·哈迪森", "陈嘉"],
    duration: "115分钟",
    tagline: "越往下潜，光越远，人心越近。",
    synopsis:
      "深海钻井平台突发事故，一支救援小队必须在氧气耗尽前抵达海底舱室。随着深度增加，他们发现真正的危险来自彼此隐瞒的秘密。",
    episodes: [],
  },
  {
    id: "laugh-lane",
    title: "爆笑江湖",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20comedy%20movie%20poster%20art%2C%20colorful%20playful%20street%20scene%20with%20vintage%20signs%2C%20bright%20cheerful%20lighting%2C%20warm%20amber%20and%20cream%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m7&orientation=portrait",
    genres: ["喜剧"],
    region: "中国大陆",
    year: 2024,
    rating: 7.2,
    popularity: 68,
    publishedAt: "2024-08-08",
    director: "王大锤",
    actors: ["赵小宝", "钱多多", "孙大圣"],
    duration: "108分钟",
    tagline: "日子再难，也要笑出声来。",
    synopsis:
      "三个总想一夜暴富的小人物在小城开了一家假古董店。一场意外让他们卷进了真正的江湖纷争，笑料与温情齐飞。",
    episodes: [],
  },
  {
    id: "shanshan-tale",
    title: "山海奇缘",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20animated%20fantasy%20movie%20poster%20art%2C%20mystical%20mountains%20and%20floating%20creatures%20in%20soft%20mist%2C%20whimsical%20lighting%2C%20jade%20green%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m8&orientation=portrait",
    genres: ["动画", "奇幻"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    popularity: 85,
    publishedAt: "2025-02-10",
    director: "墨白",
    actors: ["配音：花浅", "配音：石岩", "配音：陆离"],
    duration: "102分钟",
    tagline: "山海之间，藏着每个人都曾相信的奇迹。",
    synopsis:
      "少年为寻找失踪的姐姐闯入山海秘境。他与一只会说人话的神兽结伴，在奇幻旅程中重新理解了勇气与告别的意义。",
    episodes: [],
  },
  {
    id: "doom-echo",
    title: "末日回响",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20post%20apocalyptic%20thriller%20movie%20poster%20art%2C%20lone%20figure%20in%20a%20ruined%20hazy%20cityscape%2C%20tense%20moody%20lighting%2C%20deep%20grey%20navy%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m9&orientation=portrait",
    genres: ["科幻", "惊悚"],
    region: "韩国",
    year: 2024,
    rating: 7.5,
    popularity: 66,
    publishedAt: "2024-11-22",
    director: "朴在勋",
    actors: ["金泰宇", "尹素拉", "崔民浩"],
    duration: "121分钟",
    tagline: "世界安静下来后，回声才最响。",
    synopsis:
      "一场全球性的声波灾难让城市沦为废墟。一名幸存者依靠一台老旧收音机寻找其他生还者，却在信号中听到了不该存在的呼唤。",
    episodes: [],
  },
  {
    id: "city-light",
    title: "城市之光",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20movie%20poster%20art%2C%20city%20skyline%20at%20dusk%20with%20a%20silhouetted%20figure%2C%20moody%20blue%20hour%20lighting%2C%20deep%20navy%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-m10&orientation=portrait",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    popularity: 79,
    publishedAt: "2025-04-18",
    director: "周牧",
    actors: ["罗晋", "袁泉", "白宇"],
    duration: "119分钟",
    tagline: "每盏灯下，都有一个不肯认输的人。",
    synopsis:
      "一名外卖骑手、一位夜班护士和一名落魄设计师在城市深夜相遇。三条看似平行的命运，因为一次意外彼此照亮。",
    episodes: [],
  },
  {
    id: "mist-archive",
    title: "迷雾档案馆",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20tv%20series%20poster%20art%2C%20dim%20archive%20room%20with%20floating%20dust%20and%20old%20files%2C%20eerie%20moody%20lighting%2C%20deep%20navy%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-t1&orientation=portrait",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    popularity: 94,
    publishedAt: "2025-05-06",
    director: "顾长安",
    actors: ["秦川", "苏黎", "何晟"],
    duration: "全8集",
    tagline: "每一份档案背后，都是一段被隐藏的人生。",
    synopsis:
      "一座专门存放悬案的档案馆迎来新管理员。随着一份份尘封卷宗被重新打开，他发现这些案件之间，藏着一个跨越三十年的共同答案。",
    episodes: [
      { id: "mist-archive-1", index: 1, title: "第1集 · 迷雾初现", duration: "45分钟" },
      { id: "mist-archive-2", index: 2, title: "第2集 · 空白的一页", duration: "44分钟" },
      { id: "mist-archive-3", index: 3, title: "第3集 · 深夜来电", duration: "46分钟" },
      { id: "mist-archive-4", index: 4, title: "第4集 · 老照片里的人", duration: "43分钟" },
      { id: "mist-archive-5", index: 5, title: "第5集 · 交叉的线索", duration: "45分钟" },
      { id: "mist-archive-6", index: 6, title: "第6集 · 档案馆之夜", duration: "47分钟" },
      { id: "mist-archive-7", index: 7, title: "第7集 · 真相的边角", duration: "44分钟" },
      { id: "mist-archive-8", index: 8, title: "第8集 · 迷雾散尽", duration: "52分钟" },
    ],
  },
  {
    id: "tang-dynasty",
    title: "大唐风云录",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20tv%20series%20poster%20art%2C%20grand%20ancient%20chinese%20palace%20with%20red%20pillars%2C%20regal%20dramatic%20lighting%2C%20deep%20indigo%20and%20gold%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-t2&orientation=portrait",
    genres: ["古装", "历史", "权谋"],
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    popularity: 97,
    publishedAt: "2024-11-01",
    director: "郑道远",
    actors: ["王劲松", "陈道明", "倪妮"],
    duration: "全40集",
    tagline: "庙堂之高，江湖之远，皆在一念之间。",
    synopsis:
      "以盛唐由盛转衰为背景，讲述一位寒门子弟在朝堂权谋中步步为营，却始终试图守住初心的传奇一生。",
    episodes: [
      { id: "tang-dynasty-1", index: 1, title: "第1集 · 长安入仕", duration: "45分钟" },
      { id: "tang-dynasty-2", index: 2, title: "第2集 · 朝堂初立", duration: "45分钟" },
      { id: "tang-dynasty-3", index: 3, title: "第3集 · 暗流涌动", duration: "46分钟" },
      { id: "tang-dynasty-4", index: 4, title: "第4集 · 边关烽火", duration: "45分钟" },
      { id: "tang-dynasty-5", index: 5, title: "第5集 · 权力的代价", duration: "47分钟" },
      { id: "tang-dynasty-6", index: 6, title: "第6集 · 风云突变", duration: "48分钟" },
    ],
  },
  {
    id: "urban-floating",
    title: "都市浮生记",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20tv%20series%20poster%20art%2C%20couple%20walking%20through%20a%20night%20city%20street%20with%20bokeh%20lights%2C%20warm%20cinematic%20lighting%2C%20deep%20navy%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-t3&orientation=portrait",
    genres: ["都市", "爱情"],
    region: "中国大陆",
    year: 2025,
    rating: 7.9,
    popularity: 83,
    publishedAt: "2025-03-15",
    director: "许安",
    actors: ["杨紫", "肖战", "范湉湉"],
    duration: "全24集",
    tagline: "在这座城市，我们都努力活成想要的样子。",
    synopsis:
      "五个背景各异的年轻人在同一栋公寓楼相遇。他们的求职、恋爱与梦想，交织成一幅真实而温暖的都市浮世绘。",
    episodes: [
      { id: "urban-floating-1", index: 1, title: "第1集 · 搬家第一天", duration: "42分钟" },
      { id: "urban-floating-2", index: 2, title: "第2集 · 陌生的邻居", duration: "43分钟" },
      { id: "urban-floating-3", index: 3, title: "第3集 · 加班的夜", duration: "42分钟" },
      { id: "urban-floating-4", index: 4, title: "第4集 · 心动的信号", duration: "44分钟" },
      { id: "urban-floating-5", index: 5, title: "第5集 · 各自的难题", duration: "43分钟" },
      { id: "urban-floating-6", index: 6, title: "第6集 · 留在城市", duration: "45分钟" },
    ],
  },
  {
    id: "healer-heart",
    title: "医者仁心",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20tv%20series%20poster%20art%2C%20doctor%20in%20a%20bright%20modern%20hospital%20corridor%2C%20clean%20dramatic%20lighting%2C%20cool%20navy%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-t4&orientation=portrait",
    genres: ["医疗", "职业", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    popularity: 77,
    publishedAt: "2024-07-19",
    director: "刘思远",
    actors: ["靳东", "海清", "张子枫"],
    duration: "全30集",
    tagline: "白大褂的重量，是无数个不眠之夜。",
    synopsis:
      "急诊科医生与年轻实习生在一场场生死抢救中相互磨合。在专业与人性的双重考验下，他们重新定义了「医者」二字。",
    episodes: [
      { id: "healer-heart-1", index: 1, title: "第1集 · 急诊夜", duration: "44分钟" },
      { id: "healer-heart-2", index: 2, title: "第2集 · 第一次抢救", duration: "43分钟" },
      { id: "healer-heart-3", index: 3, title: "第3集 · 医疗抉择", duration: "45分钟" },
      { id: "healer-heart-4", index: 4, title: "第4集 · 难得清醒", duration: "44分钟" },
      { id: "healer-heart-5", index: 5, title: "第5集 · 白衣执甲", duration: "46分钟" },
      { id: "healer-heart-6", index: 6, title: "第6集 · 仁心长存", duration: "48分钟" },
    ],
  },
  {
    id: "rainy-journey",
    title: "江湖夜雨十年灯",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20martial%20arts%20tv%20series%20poster%20art%2C%20swordsman%20in%20flowing%20robes%20on%20a%20misty%20mountain%20cliff%2C%20dramatic%20lighting%2C%20deep%20indigo%20and%20amber%20tone%2C%20minimal%20background%2C%20centered%20composition%2C%20high%20detail%2C%20key%20art%2C%20no%20text&width=500&height=750&seq=md-t5&orientation=portrait",
    genres: ["武侠", "古装", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    popularity: 89,
    publishedAt: "2025-06-01",
    director: "白鹤",
    actors: ["陈飞宇", "周也", "张颂文"],
    duration: "全36集",
    tagline: "十年一别，江湖仍是那场夜雨。",
    synopsis:
      "一位隐退多年的剑客被一封信重新卷入江湖。旧友、仇敌与未了的情缘在未来十年间一一赴约，铺开一幅苍凉的武侠长卷。",
    episodes: [
      { id: "rainy-journey-1", index: 1, title: "第1集 · 夜雨来客", duration: "45分钟" },
      { id: "rainy-journey-2", index: 2, title: "第2集 · 旧梦重逢", duration: "44分钟" },
      { id: "rainy-journey-3", index: 3, title: "第3集 · 剑指何方", duration: "46分钟" },
      { id: "rainy-journey-4", index: 4, title: "第4集 · 江湖旧账", duration: "45分钟" },
      { id: "rainy-journey-5", index: 5, title: "第5集 · 长夜将尽", duration: "47分钟" },
      { id: "rainy-journey-6", index: 6, title: "第6集 · 十年灯火", duration: "50分钟" },
    ],
  },
];

export const heroSlides = [
  {
    id: "hero-1",
    targetId: "interstellar-dawn",
    kicker: "本周焦点 · 独家首映",
    title: "星际迷航：黎明边境",
    desc: "穿越星门，抵达人类从未见过的黄昏行星。年度科幻巨制，正在热映。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20science%20fiction%20epic%20space%20scene%2C%20spaceship%20before%20a%20giant%20glowing%20planet%2C%20deep%20navy%20and%20amber%20cinematic%20color%20grading%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20haze%2C%20high%20detail%20film%20still%2C%20no%20text&width=1600&height=900&seq=md-hero-1&orientation=landscape",
  },
  {
    id: "hero-2",
    targetId: "night-hunt",
    kicker: "悬疑力作 · 口碑飙升",
    title: "暗夜追凶",
    desc: "一桩旧案，牵出二十年的沉默真相。看完第一遍，你会想再看一遍。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20rainy%20neon%20city%20night%20with%20a%20lone%20figure%2C%20deep%20navy%20and%20amber%20cinematic%20color%20grading%2C%20dramatic%20volumetric%20lighting%2C%20film%20noir%20atmosphere%2C%20high%20detail%20film%20still%2C%20no%20text&width=1600&height=900&seq=md-hero-2&orientation=landscape",
  },
  {
    id: "hero-3",
    targetId: "changan-dream",
    kicker: "古装奇幻 · 东方美学",
    title: "长安幻夜",
    desc: "灯影摇曳处，藏着长安不为人知的另一面。一场跨越二十年的幻梦。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20ancient%20chinese%20fantasy%20palace%20at%20night%20with%20lanterns%2C%20deep%20indigo%20and%20gold%20cinematic%20grading%2C%20dramatic%20volumetric%20lighting%2C%20atmospheric%20mist%2C%20high%20detail%20film%20still%2C%20no%20text&width=1600&height=900&seq=md-hero-3&orientation=landscape",
  },
  {
    id: "hero-4",
    targetId: "velocity-fury",
    kicker: "动作爽片 · 极速上线",
    title: "极速狂飙",
    desc: "在这条街上，只有快和更快。三座城市的飙车阴谋已经启动。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20sleek%20car%20racing%20through%20a%20night%20city%20with%20light%20trails%2C%20deep%20navy%20and%20amber%20cinematic%20grading%2C%20dynamic%20motion%20lighting%2C%20high%20energy%20atmosphere%2C%20high%20detail%20film%20still%2C%20no%20text&width=1600&height=900&seq=md-hero-4&orientation=landscape",
  },
  {
    id: "hero-5",
    targetId: "deep-rescue",
    kicker: "灾难冒险 · 深海极限",
    title: "深海救援",
    desc: "越往下潜，光越远，人心越近。氧气耗尽前的最后一场营救。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20diver%20descending%20into%20a%20deep%20glowing%20ocean%20trench%2C%20deep%20teal%20navy%20and%20amber%20cinematic%20grading%2C%20dramatic%20volumetric%20light%20rays%2C%20high%20detail%20film%20still%2C%20no%20text&width=1600&height=900&seq=md-hero-5&orientation=landscape",
  },
];

export const genreOptions = [
  "科幻",
  "悬疑",
  "犯罪",
  "古装",
  "奇幻",
  "剧情",
  "爱情",
  "动作",
  "喜剧",
  "动画",
  "惊悚",
  "都市",
  "历史",
  "武侠",
  "医疗",
];

export const regionOptions = ["中国大陆", "中国香港", "中国台湾", "美国", "英国", "日本", "韩国"];

export const yearOptions = [2025, 2024, 2023, 2022, 2021, 2020];